import React from "react";
import { connect } from "react-redux";
import { useMemo } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import classnames from "classnames";
import NavigationActions from "redux/navigation/actions";
import ReactTableWrapper from "../../../components/reacttable/reacttbl.style";
import Pagination from "@mui/material/Pagination";
import PlaceHolderImage from "../../../assets/images/placeholder.png";

const { success, error } = NavigationActions;
const Staffservicetable = props => {
  const { staffData, staffServiceMap, loading } = props;
  const HeaderComponent = props => {
    let classes = {
      "my-2": true,
      "mx-3": true,
      "-sort-asc": props.isSortedDesc !== undefined && !props.isSortedDesc,
      "-sort-desc": props.isSortedDesc !== undefined && props.isSortedDesc
    };
    return <div className={classnames(classes)}>{props.title}</div>;
  };

  const uniqueStaffData = useMemo(() => {
    if (!Array.isArray(staffData)) return [];
    const seen = new Set();
    return staffData.filter(item => {
      const id = item?._id || item?.id;
      if (!id) return true;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }, [staffData]);

  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Staff-Image"
            />
          );
        },
        placeholder: "staff_image",
        accessor: "file_image",
        Cell: tableInstance => (
          <span>
            <img
              src={
                tableInstance.row.original?.file_image
                  ? `${process.env.REACT_APP_UPLOAD_DIR}${tableInstance.row.original?.file_image}`
                  : PlaceHolderImage
              }
              className="profile-img"
              alt="no"
              width={60}
              onError={e => {
                e.target.src = PlaceHolderImage;
              }}
            />
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Staff-Name"
            />
          );
        },
        placeholder: "staff_name",
        accessor: "name",
        Cell: tableInstance => <span>{tableInstance.row.original?.name}</span>
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Staff-Email"
            />
          );
        },
        placeholder: "staff_email",
        accessor: "email",
        Cell: tableInstance => <span>{tableInstance.row.original?.email}</span>
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Services"
            />
          );
        },
        placeholder: "services",
        accessor: "service_data",
        Cell: tableInstance => {
          const staffId = tableInstance.row.original?._id;
          const allServices = tableInstance.row.original?.service_data || [];

          // Get assigned service IDs for this staff from staffServiceMap
          const assignedServiceIds =
            staffServiceMap
              ?.filter(mapping => mapping.staff_data?.includes(staffId))
              .map(mapping => mapping.service_id) || [];

          // Filter services to only show those assigned to this staff
          const assignedServices = allServices.filter(service =>
            assignedServiceIds.includes(service._id)
          );

          return (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {assignedServices.length > 0 ? (
                assignedServices.map((service, index) => (
                  <span
                    key={service._id || index}
                    style={{
                      display: "inline-block",
                      padding: "4px 12px",
                      fontSize: "12px",
                      fontWeight: "500",
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      borderRadius: "16px",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {service.name}
                  </span>
                ))
              ) : (
                <span style={{ color: "#999", fontSize: "14px" }}>
                  No services assigned
                </span>
              )}
            </div>
          );
        }
      }
    ],
    [uniqueStaffData]
  );
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    page,
    headerGroups
  } = useTable(
    {
      data: uniqueStaffData,
      columns: columns,
      initialState: {
        pageSize: 10,
        pageIndex: 0
      }
    },
    useSortBy,
    usePagination
  );
  return (
    <ReactTableWrapper {...props}>
      <div className="roe-card-style mt-15 mb-30">
        <div className="roe-card-header">
          <span className="hash"># </span> Room-Staff
        </div>
        <div className="table-container text-left overflow-auto mt-4">
          <table
            border={1}
            className="custom-react-table-theme-class"
            {...getTableProps()}
          >
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(header => (
                    <th
                      {...header.getHeaderProps(header.getSortByToggleProps())}
                    >
                      <div>{header.render("Header")}</div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {/* {headerGroups.map(headerGroup => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map(header => {
                                            return (
                                                <td
                                                    {...header.getHeaderProps(
                                                        header.getSortByToggleProps()
                                                    )}
                                                >
                                                    <div>
                                                        {header.canFilter ? header.render("Filter") : null}
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))} */}
              {uniqueStaffData.length > 0
                ? page?.map(row => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map(cell => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                : !loading && (
                    <tr>
                      {
                        <td className="mt-4 text-left font-weight-bold">
                          <h5>No data found</h5>
                        </td>
                      }
                    </tr>
                  )}
            </tbody>
          </table>
        </div>
        <div className="float-right" style={{ display: "none" }}>
          <Pagination
            // onPageChange={gotoPage}
            pages={1}
            // page={pageIndex}
            // count={pageCount}
            onChange={(e, val) => {
              // setPageCng(val);
            }}
          />
        </div>
      </div>
    </ReactTableWrapper>
  );
};
const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, { success, error })
)(Staffservicetable);
